<template>
  <div class="nd-footer">
    <div class="nd-footer-bar"></div>
  </div>
</template>
